import { useState } from "react";

type UseEditorFloorResult = {
  /** Height the open editor may not shrink below. */
  editorFloor?: number;
  /** Call when a drag resizes the cell — it raises the floor. */
  setEditorFloor: (height: number) => void;
};

/**
 * Tracks the height an open editor may not shrink below: the cell's stored
 * height when the editor opened, then updated by drags — never by typing,
 * so deleting text shrinks the cell back down to it.
 */
export const useEditorFloor = (
  isEditorOpen: boolean,
  storedHeight?: number,
): UseEditorFloorResult => {
  const [editorFloor, setEditorFloor] = useState<number | undefined>(undefined);
  const [wasEditorOpen, setWasEditorOpen] = useState(false);

  // Capture the floor on the open transition. Setting state during render
  // is React's "adjust state when a prop changes" pattern: React retries
  // this component once (before children render or anything commits) and
  // the guard is then false — no loop, and no committed intermediate
  // render like an effect would produce.
  if (isEditorOpen !== wasEditorOpen) {
    setWasEditorOpen(isEditorOpen);
    if (isEditorOpen) {
      setEditorFloor(storedHeight);
    }
  }

  return { editorFloor, setEditorFloor };
};
